<section class="dashboard">
  <div class="hero">
    <h1>Welcome back</h1>
    <p class="intro">
      You are signed in as <strong>{{ currentUser?.email }}</strong>.
    </p>
  </div>

  <div class="actions">
    <a class="btn primary" routerLink="/app/upload">Upload statement</a>
    <a class="btn ghost" routerLink="/app/statements">View statements</a>
  </div>

  <div class="cards">
    <div class="card">
      <h2>Statements</h2>
      <p>Upload bank or provider statement files and track their ingestion status.</p>
    </div>

    <div class="card">
      <h2>Next step</h2>
      <p>After statement upload is stable, the next vertical is reconciliation execution.</p>
    </div>
  </div>
</section>
